import { LOGIN, LOGOUT, ADMIN_LOGIN, ADMIN_LOGOUT, STORE_BOOK, AUTHOR_LOGIN, AUTHOR_LOGOUT } from "../types/type";

export const login = (userData) => dispatch => {
    dispatch({
        type: LOGIN,
        payload: userData
    })
}

export const logout = () => dispatch => {
    dispatch({
        type: LOGOUT
    })
}

export const authorLogin = (token) => async dispatch => {
    dispatch({
        type:AUTHOR_LOGIN,
        payload:token
    })
}

export const authorLogout = (token) => async dispatch => {
    dispatch({
        type:AUTHOR_LOGOUT
    })
}

export const adminLogin = (token) => async dispatch => {
    dispatch({
        type: ADMIN_LOGIN,
        payload: token
    })
}

export const adminLogout = () => async dispatch => {
    dispatch({
        type: ADMIN_LOGOUT
    })
}

export const storeBook = (bookData) => async dispatch => {
    dispatch({
        type: STORE_BOOK,
        payload: bookData
    })
}